<template>
    <div class="MCourseEvaluation">
        <div v-if="commentData.isjoin === 1 && commentData.iscomment === 0" class="eva_btn_bx">
            <p>快来说说你对本课程的感受吧！</p>
            <van-button @click="evaluatePop = true" type="info" size="small">立即评价</van-button>
        </div>
        <div class="comment_content_box">
            <p class="good_text">本课程好评度 {{commentData.goodcommentrate}}%</p>
            <div class="handle_box">
                <div @click="handleValueClick('')" :class="handleValue === '' ? 'active' : ''">全部({{commentData.commentcount-1}})</div>
                <div @click="handleValueClick(1)" :class="handleValue === 1 ? 'active' : ''">好评({{commentData.goodcomment-1}})</div>
                <div @click="handleValueClick(2)" :class="handleValue === 2 ? 'active' : ''">中评({{commentData.mediumcomment}})</div>
                <div @click="handleValueClick(3)" :class="handleValue === 3 ? 'active' : ''">差评({{commentData.badcomment}})</div>
            </div>
            <div class="comment_list_box">
                <div v-if="commentData.conmentinfo.length > 0">
                    <pull2 :pull="pull" :page="page" @getList="getList">
                        <div class="comment_item_box" v-for="(item, index) in commentData.conmentinfo" :key="index">
                            <div class="user_box">
                                <img :src="item.customeratturl === '' || item.customeratturl === ' ' ? require('@/common/images/header/user.png') : item.customeratturl" alt="">
                                <div>
                                    <p>
                                        <span>{{item.customername}}</span>
                                        <span>{{item.datetime}}</span>
                                    </p>
                                    <p><el-rate v-model="item.evaluatecount" disabled></el-rate></p>
                                </div>
                            </div>
                            <p class="comment_text">{{item.content}}</p>
                        </div>
                    </Pull2>    
                </div>
                <div v-if="commentData.conmentinfo.length === 0" class="no_data_box">
                    <img :src="require('@/common/images/mobile/img-noData.png')" alt="">
                    <p>暂无评论信息</p>
                </div>
            </div>
        </div>
        <div class="evaluate_pop">
            <van-popup v-model="evaluatePop" position="center">
                <div class="evaluate_div">
                    <div>
                        <van-rate v-model="courseEvaValue" allow-half @change="evaChange" void-color="#E5E5E5"/>
                        <p>{{courseEvaText}}</p>
                        <van-cell-group>
                            <van-field maxlength='90' v-model="discussMsg" type="textarea" placeholder="请说说你对本课程的看法…(不超过90字)" rows="5" autosize/>
                        </van-cell-group>
                    </div>
                    <div class="btn_div">
                        <div @click="evaluatePop = false">取消</div>
                        <div @click="subCourseEva">提交</div>
                    </div>
                </div>
            </van-popup>
        </div>
        <div class="join_evasuccess_pop">
            <van-popup v-model="evaSuccessPop" @close="closePop" position="center">
                <div class="join_evasuccess_div">
                    <img :src="require('@/common/images/mmy/icon_success.png')" alt="">
                    <p>您已成功参与课程评价</p>
                    <div @click="sureBtn">确定</div>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
import Pull2 from 'views/mobile/components/pull/pull2'
import {getCourseComment, uploadCourseComment} from 'api/api'
import {Toast} from 'vant'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'MCourseEvaluation',
    data() {
        return {
            handleValue: '', // 评价类型  ''：全部  1：好评  2：中评  3：差评
            commentData: {
                conmentinfo: []
            },
            courseEvaValue: 5, // 评价星 分数
            courseEvaText: '推荐，课程非常棒！', // 评价星数对应文字
            discussMsg: '', // 评价内容
            evaluatePop: false, // 评价课程弹窗
            evaSuccessPop: false, // 评价成功弹窗
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 2,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            }
        }
    },
    mounted() {
        // this.findCourseComment(1)
        if (!this.refresh) {
            this.findCourseComment(1)
        }
    },
    activated () {
        if (this.refresh) {
            this.findCourseComment(1)
            this.handleValue = ''
            this.setRefresh(false)
        }
    },
    methods: {
        handleValueClick(val) {
            this.handleValue = val
            this.findCourseComment(1)
            // if (val === '') {}
        },
        // 获取用户评价接口（详情页）
        findCourseComment(val) {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                page: val,
                pageSize: 10,
                conmenttype: this.handleValue
            }
            if(this.evaRadioValue === 0) {
                params.conmenttype = ''
            }
            getCourseComment({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.commentData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        getList() {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                conmenttype: this.handleValue
            }
            getCourseComment({
                data: Object.assign({}, params, this.page),
                success: data => {
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.commentData = data.data.notesinfo
                    } else {
                        this.commentData = this.commentData.concat(data.data)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 提交课程评价
        subCourseEva() {
            if (this.discussMsg === '') {
                Toast('评价内容不能为空')
            } else {
                this.setLoading(true)
                var params = {
                    courseid: this.$route.query.cid,
                    content: this.discussMsg,
                    evaluatecount: this.courseEvaValue
                }
                uploadCourseComment({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        console.log(data.data)
                        this.evaluatePop = false
                        this.evaSuccessPop = true
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }
        },
        // 课程评分改变
        evaChange() {
            // console.log(this.courseEvaValue)
            if (this.courseEvaValue < 1.5) {
                this.courseEvaText = '极差，课程很糟糕，我要吐槽'
            } else if (this.courseEvaValue >= 1.5 && this.courseEvaValue < 2.5) {
                this.courseEvaText = '差，我对课程不满意。'
            } else if (this.courseEvaValue >= 2.5 && this.courseEvaValue < 3.5) {
                this.courseEvaText = '中评，课程一般。'
            } else if (this.courseEvaValue >= 3.5 && this.courseEvaValue < 4.5) {
                this.courseEvaText = '良好，课程还可以。'
            } else if (this.courseEvaValue >= 4.5) {
                this.courseEvaText = '推荐，课程非常棒！'
            }
        },
        // 评价成功弹窗确认按钮
        sureBtn() {
            this.commentData.iscomment = 1
            this.evaSuccessPop = false
            this.handleValue = ''
            this.findCourseComment(1)
        },
        // 评价成功弹窗关闭事件
        closePop() {
            // console.log('关闭')
            this.commentData.iscomment = 1
            this.evaSuccessPop = false
            this.handleValue = ''
            this.findCourseComment(1)
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['loginPop', 'user', 'refresh'])
    },
    components: {Pull2}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .MCourseEvaluation {
        width: 100vw;
        min-height: 100vh;
        color: #333;
        background-color: rgb(255, 255, 255);
        // padding-bottom: 1rem;
        .eva_btn_bx {
            padding: 0 0.32rem;
            height: 0.86rem;
            background-color: #FFF7EC;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &>p {
                font-size: 0.26rem;
            }
            .van-button {
                font-size: 0.24rem;
                width: 1.48rem;
                height: 0.52rem;
                line-height: 0.5rem;
            }
        }
        .comment_content_box {
            padding: 0 0.32rem;
            .good_text {
                line-height: 0.4rem;
                font-size: 0.28rem;
                padding: 0.28rem 0;
            }
            .handle_box {
                display: flex;
                justify-content: space-between;
                margin-bottom: 0.16rem;
                &>div {
                    box-sizing: border-box;
                    text-align: center;
                    font-size: 0.24rem;
                    width: 1.59rem;
                    height: 0.58rem;
                    line-height: 0.58rem;
                    border:0.02rem solid rgba(229,229,229,1);
                    border-radius:0.32rem;
                }
                .active {
                    border-color: #409EFF;
                    color: #409EFF;
                    background-color: #F2F8FF;
                }
            }
            .comment_list_box {
                .van-pull-refresh {
                    min-height: 60vh;
                }
                .comment_item_box {
                    padding: 0.32rem 0;
                    border-bottom: 1px solid #E5E5E5;
                    .user_box {
                        display: flex;
                        align-items: center;
                        &>img {
                            width: 0.8rem;
                            height: 0.8rem;
                            border-radius: 50%;
                            margin-right: 0.2rem;
                        }
                        &>div {
                            flex: 1;
                            &>p:nth-of-type(1) {
                                font-size: 0.24rem;
                                display: flex;
                                justify-content: space-between;
                                line-height: 0.33rem;
                                margin-bottom: 0.04rem;
                                span:nth-of-type(2){
                                    color: #999;
                                }
                            }
                            // &>p:nth-of-type(2) {
                            //     background-color: red;
                            //     height: 0.22rem;
                            //     align-items: center;
                            // }
                        }
                    }
                    .comment_text {
                        margin-top: 0.2rem;
                        text-align: justify;
                        padding-left: 1rem;
                        line-height: 0.4rem;
                        font-size: 0.26rem;
                    }
                }
                .comment_item_box:nth-last-of-type(1){
                    border: none;
                }
                .no_data_box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 3rem 0;
                    &>img{
                        width: 1.68rem;
                        height: 1.62rem;
                    }
                    &>p {
                        margin-top: 0.3rem;
                        color: #999;
                        font-size: 0.26rem;
                        line-height: 0.4rem;
                    }
                }
            }
        }
        .evaluate_pop {
            .van-popup--center {
                border-radius:0.15rem;
                .evaluate_div {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    width: 5rem;
                    &>div:nth-of-type(1){
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding-top: 0.48rem;
                        &>p {
                            margin: 0.3rem 0;
                            line-height: 0.4rem;
                            font-size: 0.28rem;
                        }
                        .van-cell {
                            box-sizing: border-box;
                            padding: 0.2rem 0.16rem;
                            background-color: #F5F5F5;
                            width: 5rem;
                            height: 3.66rem;
                            font-size: 0.26rem
                        }
                        .van-field__control {
                            line-height: 0.4rem;
                            text-align: justify;
                        }
                    }
                    .btn_div {
                        width: 5rem;
                        display: flex;
                        &>div {
                            font-size: 0.32rem;
                            text-align: center;
                            line-height: 0.9rem;
                            width: 50%;
                            color: #409EFF;
                        }
                        &>div:active {
                            background-color: rgb(247, 247, 247);
                        }
                        &>div:nth-of-type(1) {
                            color: #666;
                            border-right: 0.01rem solid #E5E5E5;
                        }
                    }
                }
            }
        }
        .join_evasuccess_pop {
            .van-popup--center {
                background-color: transparent;
                .join_evasuccess_div {
                    box-sizing: border-box;
                    padding-top: 0.92rem;
                    background-color: #FFF;
                    width: 5rem;
                    border-radius:0.15rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    &>img{
                        width: 2.24rem;
                        height: 1.6rem;
                    }
                    &>p {
                        margin-top: 0.39rem;
                        margin-bottom: 0.59rem;
                        font-size: 0.28rem;
                        line-height: 0.4rem;
                    }
                    &>div {
                        width: 5rem;
                        border-top: 0.01rem solid #E5E5E5;
                        height: 0.9rem;
                        line-height: 0.9rem;
                        box-sizing: border-box;
                        text-align: center;
                        font-size: 0.32rem;
                        color: #409EFF;
                    }
                    &>div:active {
                        background-color: rgb(243, 243, 243);
                        border-radius: 0 0 0.15rem 0.15rem;
                    }
                }
            }
        }
    }
</style>